import { Grid2 as Grid, Stack, Typography } from "@mui/material"
import InputField1 from "../../../../components/ui/InputField1"
import { useSelector } from "react-redux"

function ContactInfo() {
  const { specialist } = useSelector(state => state.specialistSlice)

  return (
    <Grid size={12}>
      <Typography
        sx={{
          mb: 1,
          fontSize: "16px",
          fontWeight: "600",
          color: "other.color1",
        }}
      >Contact Information *
      </Typography>
      <Stack spacing={1}>
        <InputField1
          disabled
          name="name"
          type="text"
          placeholder="Name"
          value={specialist?.specialist?.fullName}
        />
        <InputField1
          disabled
          name="email"
          type="email"
          placeholder="Email"
          value={specialist?.specialist?.email}
        />
        <InputField1
          disabled
          name="phone"
          type="text"
          placeholder="Phone"
          value={specialist?.specialist?.phone}
        />  <InputField1
          disabled
          label={"Years of Experience *"}
          name="Experience"
          type="text"
          placeholder="Experience"
          value={specialist?.experties?.experience}
        />
      </Stack>
    </Grid>
  )
}

export default ContactInfo